import {makeAutoObservable} from "mobx";
import axios from "axios";
import axiosUserInstance from "../axiosUser";


export default class LoginStore {
    entrepriseData = null;

    constructor() {
        makeAutoObservable(this);
    }

    isUserConnected() {
        return this.getCookie("user_apiToken") !== null; // Retourne true si le cookie existe, sinon false
    }

    async getOtpMail(email) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/otp`, {
                params: {
                    email: email
                },
            });
            console.log(response.data)
            return response.data;
        } catch (e) {
            return e.response?.data ?? {
                status: false,
                message: "La demande de code n'a pas pu aboutir. Vérifiez votre connexion puis réessayez."
            };
        }
    }

    async checkOtpMail(email, otp) {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/otp`, {
                email: email,
                otp: otp
            });

            if (response.data.status) {
                console.log("response.data.status", response.data.status);
                let date = new Date();
                date.setFullYear(date.getFullYear() + 10); // Ajoute 10 ans à la date actuelle

                // Stocke le token dans un cookie
                document.cookie = "user_apiToken=" + response.data.token + "; path=/; expires=" + date.toUTCString() + "; SameSite=None; Secure";

                // Stocke les infos utilisateur dans un cookie
                document.cookie = "currentUserInfos=" + JSON.stringify(response.data.userInfos) + "; path=/; expires=" + date.toUTCString() + "; SameSite=None; Secure";

                // Gestion du nombre d'entreprises
                const userInfos = response.data.userInfos;
                if (userInfos.nb_entreprises > 1) {
                    return {redirect: "/choixEspace", token: response.data.token}; // Renvoie vers choix d'espace
                } else if (userInfos.nb_entreprises === 1) {
                    const entreprises = await this.loadEntreprises();  // Charge les entreprises

                    // Si une seule entreprise, renvoie l'URL pour redirection
                    if (entreprises.length === 1) {
                        await this.loadEntrepriseData(entreprises[0].code); // Attendre que la méthode charge les données
                        return {redirect: `/app`, token: response.data.token};
                    } else if (entreprises.length > 1) {
                        // #497 — nb_entreprises=1 mais loadEntreprises retourne plusieurs espaces
                        return {redirect: "/choixEspace", token: response.data.token};
                    } else {
                        // #497 — nb_entreprises=1 mais loadEntreprises retourne 0 espaces
                        return {error: true, message: "Impossible de charger votre espace. Veuillez réessayer."};
                    }
                } else {
                    // #497 — nb_entreprises === 0 : aucun espace associé au compte
                    return {error: true, message: "Aucun espace associé à ce compte. Contactez votre administrateur."};
                }
            } else {
                return {error: true, message: response.data.message}; // Renvoie une erreur
            }
        } catch (e) {
            // console.log("catch error checkOtpMail", e);
            return {error: true, message: "Erreur lors de la vérification de l'OTP"};
        }
    }

    // Méthode pour charger la liste des entreprises
    async loadEntreprises() {
        try {
            const response = await axiosUserInstance.get('/api/user/listeEntreprises');

            const data = response.data.entreprises; // Récupère les entreprises depuis la réponse
            this.entreprises = data; // Stocke les entreprises dans l'état

            return data; // Retourne les entreprises pour que le composant puisse les utiliser
        } catch (err) {
            console.error("Erreur lors de la récupération des entreprises :", err);
            throw err;  // Propager l'erreur pour la gestion dans le composant
        }
    }


    // Méthode pour charger les données de l'entreprise
    async loadEntrepriseData(code) {
        try {
            const response = await axiosUserInstance.get(`/api/user/EntrepriseRole/${code}`);

            if (response.data.status === true) {
                this.entrepriseData = response.data; // Stocker les données de l'entreprise dans l'état

                let date = new Date();
                date.setFullYear(date.getFullYear() + 10); // Ajoute 10 ans à la date actuelle
                // Stocke le token sous un nom fixe (current_apiToken) — plus besoin du code entreprise dans l'URL
                document.cookie = "current_apiToken=" + response.data.token + "; path=/; expires=" + date.toUTCString() + "; SameSite=None; Secure";
                // Compatibilité ascendante : conserver aussi l'ancien cookie
                document.cookie = code + "_apiToken=" + response.data.token + "; path=/; expires=" + date.toUTCString() + "; SameSite=None; Secure";
                // Stocke les infos de l'espace sous un nom fixe
                document.cookie = "currentEntrepriseInfos=" + JSON.stringify(response.data.entreprise_info) + "; path=/; expires=" + date.toUTCString() + "; SameSite=None; Secure";
                // Compatibilité ascendante
                document.cookie = code + "_currentEntrepriseInfos=" + JSON.stringify(response.data.entreprise_info) + "; path=/; expires=" + date.toUTCString() + "; SameSite=None; Secure";
            } else {
                // Entreprise non autorisée
                throw new Error('Entreprise non autorisée');
            }
        } catch (err) {
            console.error("Erreur lors de la récupération des données de l'entreprise :", err);
            throw err; // Propager l'erreur pour la gérer dans le composant
        }
    }

    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    async fetchEntreprises(token) {
        console.log("fetch")
        try {
            const response = await axiosUserInstance.get(`/api/user/listeEntreprises`);
            return response.data.entreprises; // Retourner la liste des entreprises
        } catch (err) {
            throw new Error(err.message); // Propager l'erreur
        }
    }
}
